import { render, staticRenderFns } from "./TableAlert.vue?vue&type=template&id=72812084&"
import script from "./TableAlert.vue?vue&type=script&lang=js&"
export * from "./TableAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports